export function generateLandingUrl(agentId: string, formId?: string, mode?: 'buyer' | 'seller'): string {
  const baseUrl = `https://lp.realtyai-value.com/l/${encodeURIComponent(agentId)}`;

  if (!formId && !mode) {
    return baseUrl;
  }

  const params = new URLSearchParams();
  if (formId) {
    params.append('rid', formId);
  }
  if (mode) {
    params.append('mode', mode);
  }

  return `${baseUrl}?${params.toString()}`;
}
